import * as config from './../config/config'
import api from './interceptor'


export async function get_ListeChauffeur(){
  try {
    const response = await api.get(config.REACT_APP_ENDPOINT_LIST_CHAUFFEUR);
    return response.data;
  } catch (error) {
    throw (error);
  }
};

export async function get_ListeObservationChauffeur(chauffeur_id){
  try {
    const response = await api.get(config.REACT_APP_ENDPOINT_LIST_OBSERVATION + chauffeur_id);
    return response.data;
  } catch (error) {
    throw (error);
  }
};

export async function createChauffeur(data) {
  try {
    const response = await api.post(config.REACT_APP_ENDPOINT_CREATE_CHAUFFEUR, {
      'nom' : data['nom'],
      "prenom" : data['prenom'],
      "adresse" : data['adresse'],
      "permis" : data['permis'],
      "contact": data["contact"],
      "isActive": data["isActive"],
      "images": data["avatar"],
      "cin": data["cin"]
    })
    return response.data
  } catch (error){
    throw (error);
  }
}

export async function updateChauffeur(data) {
  try {
    const response = await api.put(config.REACT_APP_ENDPOINT_UPDATE_CHAUFFEUR + "/" + data['id'], {
      'nom' : data['nom'],
      "prenom" : data['prenom'],
      "adresse" : data['adresse'],
      "permis" : data['permis'],
      "contact": data["contact"],
      "isActive": data["isActive"],
      "images": data["avatar"],
      "cin": data["cin"]
    })
    return response.data
  } catch (error){
    throw (error);
  }
}


export const deleteChauffeur = async (id) => {
    try {
        const res = await api.delete(`${config.REACT_APP_ENDPOINT_}/chauffeur/delete/${id}`);
        return res.data;
    } catch (error) {
        console.error(error);
        return { status: "error", description: error.message };
    }
};

export async function addObservation(data) {
  try {
    const response = await api.post(config.REACT_APP_ENDPOINT_ADD_OBSERVATION, {
      'chauffeur_id' : data['chauffeur_id'],
      "avertissement" : data['avertissement'],
      "description" : data['description']
    })
    return response.data
  } catch (error){
    throw (error);
  }
}

export async function exportChauffeurObservation(chauffeur_id) {
  try {
    // const response = await api.post(config.REACT_APP_ENDPOINT_EXPORT_OBSERVATION+ chauffeur_id)
    const response = await api.post(
            `${config.REACT_APP_ENDPOINT_EXPORT_OBSERVATION}${chauffeur_id}`,
            {},
            {
                responseType: "blob", // ⚠️ important : on attend un fichier binaire
            }
        );

        // 🔽 Créer un lien de téléchargement temporaire
        const blob = new Blob([response.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        // Récupérer le nom du fichier depuis les headers si le backend l’envoie
        const contentDisposition = response.headers["content-disposition"];
        console.log(contentDisposition);
        let fileName = "export_chauffeur.xlsx";
        if (contentDisposition) {
            const match = contentDisposition.match(/filename="?([^"]+)"?/);
            if (match && match[1]) fileName = match[1];
        }

        // Créer une URL temporaire et déclencher le téléchargement
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = fileName;
        document.body.appendChild(link);
        link.click();

        // Nettoyage
        document.body.removeChild(link);
        window.URL.revokeObjectURL(link.href);

        return true; // succès
  } catch (error){
    throw (error);
  }
}